import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import FormattedCurrency from '@/shared/components/FormattedCurrency';
import messages from './budgetMessages';

// Totals cover every budget matching the filters, not just the loaded page.
const BudgetTotals = ({ intl, totals }) => {
  if (!totals) return null;
  const { totalBudgetAmount = null, totalBudgetHours = null } = totals;
  if (totalBudgetAmount === null && totalBudgetHours === null) return null;

  return (
    <div className="info-block">
      <div className="flex-container">
        {totalBudgetAmount !== null && (
          <div className="flex-child-block">
            <h2>{intl.formatMessage(messages.TotalBudgetAmount)}</h2>
            <h1 className="bold">
              <FormattedCurrency value={totalBudgetAmount} />
            </h1>
          </div>
        )}
        {totalBudgetHours !== null && (
          <div
            className={
              totalBudgetAmount !== null ? 'flex-child-block separator' : 'flex-child-block'
            }
          >
            <h2>{intl.formatMessage(messages.TotalBudgetHours)}</h2>
            <h1 className="bold">
              <FormattedNumber value={totalBudgetHours} maximumFractionDigits={2} />
            </h1>
          </div>
        )}
      </div>
    </div>
  );
};

BudgetTotals.propTypes = {
  intl: intlShape.isRequired,
  totals: PropTypes.shape({
    totalBudgetAmount: PropTypes.number,
    totalBudgetHours: PropTypes.number,
  }),
};
BudgetTotals.defaultProps = {
  totals: null,
};

export default BudgetTotals;
